import { ScrollTrigger } from "../LibrariesImport";
import { GlobalVariables } from "../GlobalVariables";

// En dessous du breakpoint lg, le bloc suivant (souvent plus court en mobile) recouvrirait le
// pin avant que celui-ci n'ait fini son scrub sur 100vh : la distance de pin est donc réduite à
// 60vh, cf. même seuil que le pin desktop de BlockSolutions.js.
const DESKTOP_BREAKPOINT = 992;
const pinDistance = () => window.innerHeight * (window.innerWidth >= DESKTOP_BREAKPOINT ? 1 : 0.6);

// Épingle le bloc (data-pin-cover, cf. block.pin_and_cover) sur 100vh de scroll (60vh en mobile) :
// pinSpacing false, pour que le bloc suivant continue son flux normal et vienne le recouvrir en
// défilant par-dessus, au lieu de réserver l'espace du pin comme le ferait un pin classique.
export default class BlockTextPinCover {
	constructor() {
		if (GlobalVariables.reducedMotion) return;

		document.querySelectorAll("[data-pin-cover]").forEach((block) => {
			ScrollTrigger.create({
				trigger: block,
				start: "top top",
				// Fonction plutôt que valeur figée : ScrollTrigger la réévalue à chaque refresh (resize
				// traversant le breakpoint inclus), sans qu'il soit nécessaire de détruire/recréer le trigger.
				end: () => "+=" + pinDistance(),
				pin: true,
				pinType: "fixed",
				pinSpacing: false,
				scrub: true,
			});
		});
	}
}
